
import { defineComponent, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import { useCookie } from 'vue-cookie-next'
import { useHead } from '@vueuse/head'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const TopicRepository = RepositoryFactory.get('topic')
const AuthenticationRepository = RepositoryFactory.get('authentication')

import { Topic } from '@/types/topic'


interface UserForm {
  id: string,
  password: string,
  topic_id: number
}

export default defineComponent({
  name: 'Login',
  setup() {
    const router = useRouter()
    const cookie = useCookie()

    onMounted(() => {
      getTopics('initial')
    })

    const userForm = reactive<UserForm>({
      id: '',
      password: '',
      topic_id: 0
    })

    const isFormCompleted = computed(() => {
      const { id, password } = userForm
      return id !== '' && password !== ''
    })

    const topics: {
      list: Topic[]
      selected?: Topic

      limit: number
      page: number
      totalNumber: number

      isLoading: boolean
      infiniteScrollObserver?: IntersectionObserver
    } = reactive({
      list: [],
      selected: undefined,

      limit: 30,
      page: 1,
      totalNumber: 0,

      isLoading: false,
      infiniteScrollObserver: undefined

    })

    const getTopics = async (type: string) => {
      try {
        topics.isLoading = true

        if (type == 'initial' || type == 'search') topics.page = 1

        const dataObj = {}

        const res = await TopicRepository.getTopics(dataObj)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          if (type == 'initial' || type == 'search') {
            topics.list = data.topics
          } else {
            topics.list = topics.list.concat(data.topics)
          }

          topics.totalNumber = data.total_number

          topics.page += 1
        }
      } catch (error) {
        //
      } finally {
        topics.isLoading = false
      }
    }

    const login = async () => {
      try {
        const dataObj = {
          user_id: userForm.id,
          password: userForm.password,
          topic_id: userForm.topic_id
        }

        const res = await AuthenticationRepository.login(dataObj)

        if (res.status === 200) {
          cookie.setCookie('user_id', userForm.id)

          router.push({ name: 'seasonHome' })
        }
      } catch (error) {
        //
      }
    }

    useHead({
      title: 'ログイン',
    })

    return {
      userForm,
      isFormCompleted,

      getTopics,
      topics,

      login
    }
  }
})
